import React from "react"

import Button from "../Button"

const ButtonSecondary = ({ children, ...props }) => {
  return (
    <Button variant="outlined" {...props}>
      {children}
    </Button>
  )
}

export default ButtonSecondary
